import { Box, VStack, Text } from "@chakra-ui/react";
import { getScoreBucket } from "../helpers/scoreBuckets";

/** "XX/100" above a colored progress bar, using the same fixed buckets as ScoreBadge. */
const ScoreBar = ({ evaluation, width = "80px" }) => {
    const percent = evaluation?.scorePercent;
    if (percent == null) {
        return <Text color="text.grey" fontSize="xs">-</Text>;
    }
    const bucket = getScoreBucket(evaluation);
    const clamped = Math.min(100, Math.max(0, percent));

    return (
        <VStack gap={1} align="flex-start">
            <Text color="white" fontSize="xs">{Math.round(clamped)}/100</Text>
            <Box h="6px" w={width} bg="bg.secondary" borderRadius="full" overflow="hidden" flexShrink={0}>
                <Box h="full" bg={bucket?.color ?? "text.grey"} w={`${Math.round(clamped)}%`} borderRadius="full" />
            </Box>
        </VStack>
    );
};

export default ScoreBar;
